import React from 'react';

interface ForgotPasswordScreenProps {
    onBackToLogin: () => void;
}

const ForgotPasswordScreen: React.FC<ForgotPasswordScreenProps> = ({ onBackToLogin }) => {
    return (
        <div className="bg-white dark:bg-slate-800 p-8 rounded-lg shadow-2xl text-center flex flex-col items-center animate-fade-in w-full max-w-md mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                Recuperação de Senha
            </h2>
            <p className="text-gray-600 dark:text-slate-300 mb-6 text-left">
                Para redefinir sua senha, por favor, preencha o formulário de contato em nosso site principal. Nossa equipe de suporte receberá sua solicitação e enviará uma nova senha para o seu e-mail de cadastro.
            </p>
            
            <a
                href="https://www.odesnildo.com.br/contato"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 mb-6"
            >
                Ir para o Formulário de Contato
            </a>

            <button onClick={onBackToLogin} className="font-medium text-sm text-orange-500 hover:text-orange-400">
                &larr; Voltar para o Login
            </button>
        </div>
    );
};

export default ForgotPasswordScreen;